/** What went wrong with a save, in the server's words when it gave them. */
export default function FormAlert({ lead, message }: { lead: string; message: string }) {
  if (!message) return null;
  return (
    <div role="alert" className="rounded-md border border-danger bg-danger-tint p-3 text-caption text-danger">
      <span className="font-semibold">{lead} </span>
      {message}
    </div>
  );
}
